var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    className: "svg-content-responsive svgText",
    viewBox: "0 0 1083.321 667.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.583
    }
  }, /*#__PURE__*/React.createElement("text", {
    className: "t01",
    transform: "translate(845.321 174)",
    style: {
      fontSize: 171,
      fontFamily: "Impact"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -236.336,
    y: 0
  }, "STYLES"))), /*#__PURE__*/React.createElement("text", {
    className: "t02",
    "data-name": "Styles",
    transform: "translate(845.321 402.172)",
    style: {
      fontSize: 171,
      fontFamily: "Impact"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -236.336,
    y: 0
  }, "STYLES"))), /*#__PURE__*/React.createElement("text", {
    className: "t03",
    "data-name": "Styles",
    transform: "translate(845.321 628.782)",
    style: {
      fontSize: 171,
      fontFamily: "Impact"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -236.336,
    y: 0
  }, "STYLES"))), /*#__PURE__*/React.createElement("text", {
    className: "t04",
    transform: "translate(455.784 174)",
    style: {
      fontSize: 171,
      fontFamily: "Impact"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: -122.405,
    y: 0
  }, "THE"))), /*#__PURE__*/React.createElement("text", {
    className: "t05",
    "data-name": "the",
    transform: "translate(455.784 402.172)",
    style: {
      fontSize: 171,
      fontFamily: "Impact"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: -122.405,
    y: 0
  }, "THE"))), /*#__PURE__*/React.createElement("text", {
    className: "t06",
    "data-name": "the",
    transform: "translate(455.784 628.782)",
    style: {
      fontSize: 171,
      fontFamily: "Impact"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: -122.405,
    y: 0
  }, "THE"))), /*#__PURE__*/React.createElement("text", {
    className: "t07",
    transform: "translate(153 176)",
    style: {
      fontSize: 173,
      fontFamily: "Impact"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: -151.079,
    y: 0
  }, "LINK"))), /*#__PURE__*/React.createElement("text", {
    className: "t08",
    "data-name": "link",
    transform: "translate(153 404.172)",
    style: {
      fontSize: 173,
      fontFamily: "Impact"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: -151.079,
    y: 0
  }, "LINK"))), /*#__PURE__*/React.createElement("text", {
    className: "t09",
    "data-name": "link",
    transform: "translate(153 630.782)",
    style: {
      fontSize: 173,
      fontFamily: "Impact"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: -151.079,
    y: 0
  }, "LINK")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.f5273465b77a2bab22ff442649548255.svg";
export { ForwardRef as ReactComponent };